module.exports = __webpack_public_path__ + "img/20220325_162730.28bc4053.jpg";